// NPM Imports
import React from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Components Imports
import AddOptionToClauseBtn from "../AddOptionToClauseBtn";

// Actions Imports
import { updateDocumentClickedComponentID } from "../../../actions/DocumentActions/index";
import {
  addClauseOptions,
  editClauseOption,
} from "../../../actions/DocumentTemplateActions/templateActions";
// Services Imports

// Internal Imports
import { DOCUMENTS } from "../../../constants";
// import { COMMON, DOCUMENTS } from "../../../constants";
// import { getContentStateFromRawSectionData } from "../../../utils/components";

// Destructuring
const {
  COMPONENT_FEATURE,
  DOCUMENT_COMPONENT_TYPES,
  TEMPLATE_SHOW_CLAUSE_OPTIONS_FOR_COMPONENT_TYPE,
} = DOCUMENTS;
// const { DOCUMENT_LABELS } = COMMON;

export default function ComponentClauseOptionBtn({
  mode,
  section,
  itemType,
  clauseOptionsDetails,
  toggleUpgradePopup,
  updateStateKey,
}) {
  const dispatch = useDispatch();

  // check if clause option feature is allowed for this mode or not
  if (
    !COMPONENT_FEATURE[mode].createClauseOption ||
    itemType === DOCUMENT_COMPONENT_TYPES.COVERPAGE ||
    itemType === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER ||
    itemType === DOCUMENT_COMPONENT_TYPES.HEADER ||
    itemType === DOCUMENT_COMPONENT_TYPES.FOOTER ||
    TEMPLATE_SHOW_CLAUSE_OPTIONS_FOR_COMPONENT_TYPE.indexOf(section.type) < 0 ||
    section.clauseID
  ) {
    return null;
  }

  // if clause option is already attached then, show the both Edit and Remove button
  if (section.clauseOptions) {
    const _editClauseOption = () => {
      dispatch(editClauseOption(section, clauseOptionsDetails));
    };
    return (
      <>
        <Tooltip
          placement="top"
          overlay="Edit clause option"
          align={{ offset: [0, 3] }}>
          <span
            className="add-clause-btn"
            data-test="documentitems-edit-clause-btn"
            onMouseDown={_editClauseOption}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}>
            <i>
              <FontAwesomeIcon icon={["far", "pen-square"]} />
            </i>
            Edit Clause option
          </span>
        </Tooltip>
        <Tooltip
          placement="top"
          overlay="Remove from clauses list"
          align={{ offset: [0, 3] }}>
          <span
            className="add-clause-btn remove-clause-btn"
            data-test="documentitems-remove-clause-btn"
            onMouseDown={() =>
              updateStateKey("showRemoveClauseOptionsConfirmation", true)
            }
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}>
            <i>
              <FontAwesomeIcon icon={["far", "times-circle"]} />
            </i>
            Remove Clause option
          </span>
        </Tooltip>
      </>
    );
  }

  // check if section hs dynamic fields.
  // if dynamic fields are already attached to the section or if section is locked then,
  // disable the add clause option button
  // const contentState = getContentStateFromRawSectionData(section, mode);

  // let isDfPresent = false;
  // if (contentState) {
  //   contentState.getBlockMap().forEach(block => {
  //     block.findEntityRanges(character => {
  //       const charEntity = character.getEntity();
  //       if (charEntity) {
  //         // could be `null`
  //         const contentEntity = contentState.getEntity(charEntity);
  //         if (contentEntity.getType() === "DYNAMICFIELD") {
  //           isDfPresent = true;
  //         }
  //       }
  //     });
  //   });
  // }

  // if (isDfPresent || (section && section.lock)) {
  if (section && section.lock) {
    const tooltipText = "Cannot create clause options for locked blocks";
    // if (isDfPresent) {
    //   tooltipText = `Cannot add clause option to locked blocks or blocks with ${DOCUMENT_LABELS[
    //     "dynamic-label"
    //   ].toLowerCase()} fields.`;
    // }
    return (
      <Tooltip placement="top" overlay={tooltipText} align={{ offset: [0, 3] }}>
        <span
          className="add-clause-btn disabled"
          role="button"
          tabIndex={0}
          onMouseDown={() =>
            dispatch(
              updateDocumentClickedComponentID(section.id, false, section.type),
            )
          }>
          <i>
            <FontAwesomeIcon icon={["far", "layer-plus"]} />
          </i>
          Add Clause Option
        </span>
      </Tooltip>
    );
  }

  const _convertToClauseOption = componentId => {
    if (COMPONENT_FEATURE[mode].createClauseOption) {
      dispatch(addClauseOptions(componentId));
    }
  };

  // check if clause options is already attached or not
  return (
    <AddOptionToClauseBtn
      btnAction={_convertToClauseOption}
      id={section.id}
      toggleUpgradePopup={toggleUpgradePopup}
    />
  );
}
